import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  // General
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  // Auth
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import('../views/SignUp.vue')
  },

  // Legal
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicy.vue')
  },
  {
    path: '/terms',
    name: 'TermsOfService',
    component: () => import('../views/TermsOfService.vue')
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: () => import('../views/Impressum.vue')
  },

  // Lists
  {
    path: '/create-list',
    name: 'CreateChecklist',
    component: () => import('../views/CreateChecklist.vue')
  },
  {
    path: '/list/:slug/edit',
    name: 'EditChecklist',
    component: () => import('../views/EditChecklist.vue')
  },
  {
    path: '/lists',
    name: 'AllChecklists',
    component: () => import('../views/AllChecklists.vue')
  },
  {
    path: '/your-lists',
    name: 'UserChecklists',
    component: () => import('../views/UserChecklists.vue')
  },
  {
    path: '/list/:slug',
    name: 'ChecklistDetail',
    component: () => import('../views/ChecklistDetail.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
